export enum PhonePropertyEnum {
  MOBILE = 'mobile',
  LANDLINE = 'landline',
}
